{
  "fighter": [
    "the Iron Wall",
    "Unyielding",
    "Hammerfall",
    "Shieldborn",
    "Ironbreaker",
    "Bladewall",
    "Steelstorm",
    "the Bold",
    "the Unbroken",
    "Shieldbreaker",
    "the Steadfast",
    "Ironhand",
    "the Hammer",
    "Oathsword",
    "the Wall",
    "the Stalwart",
    "the Scarred",
    "Steelarm",
    "Ironside",
    "the Anvil",
    "Bladebreaker",
    "the Champion",
    "Spearwall",
    "Axehand",
    "Warbrand",
    "the Iron",
    "Stonefist",
    "the Bulwark",
    "Helmsplitter",
    "the Veteran",
    "Greatsword",
    "the Tested",
    "the Mailed",
    "Swordbreaker",
    "the Tireless",
    "Hardhelm",
    "the Lion",
    "Ironjaw",
    "the Brave",
    "Shieldwall",
    "Steelheart",
    "the Unbowed",
    "Battleborn",
    "the Valiant",
    "Brightsteel",
    "the Sentinel",
    "Lancebreaker",
    "the Strong",
    "the Hardy",
    "Coldsteel",
    "the Rampart",
    "Bonebreaker",
    "Ironbrow",
    "the Fearless",
    "the Dauntless",
    "Warhammer",
    "the Mighty",
    "the Undaunted",
    "Hewer",
    "Gatebreaker",
    "the Vanguard",
    "the Bear",
    "Ironmail",
    "Bloodied",
    "Swordhand",
    "the Stubborn",
    "Longblade",
    "the Swordsman",
    "Halberd",
    "Steelsworn",
    "the Grim",
    "the Stout",
    "Shieldarm",
    "Firstblade",
    "Mauler",
    "the Sergeant",
    "the Captain",
    "Ironwill",
    "Hammerhand",
    "the Bastion",
    "Redblade",
    "the Ox",
    "of the Line",
    "of the Ranks",
    "of the Shield",
    "of the Legion",
    "of the Pike",
    "of the Field",
    "of the Wall",
    "of the Breach",
    "of the Gate",
    "of the Muster",
    "of the Watch",
    "Spearhand",
    "Pikebearer",
    "Brokenhorn",
    "the Burly",
    "Hardfist",
    "the Gauntlet",
    "Ironshod",
    "Steelguard",
    "Doubleaxe",
    "the Brawler",
    "Twinblade",
    "Shieldmaiden",
    "the Duelist",
    "Fierceblade",
    "the Ironclad",
    "Blackhelm",
    "Greyhelm",
    "the Old Guard",
    "Stonewall",
    "Thunderblow",
    "Skullcleaver",
    "the Battered",
    "Stormblade",
    "the Cleaver",
    "Bronzeshield",
    "Bloodaxe",
    "the Grizzled",
    "Warborn",
    "the Hammerer",
    "Oakshield",
    "Ironshield",
    "the Tempered",
    "the Forged",
    "Steelshod",
    "Tallshield",
    "the Keeper",
    "the Sworn",
    "Brokenblade",
    "the Charger",
    "Firstspear",
    "the Last Man",
    "the Survivor",
    "the Unbent",
    "the Hard",
    "Breakwater",
    "the Stone",
    "Ironback",
    "Steelbrow",
    "the Spear",
    "the Mace",
    "Macehand",
    "Flail",
    "the Flail",
    "Trueblade",
    "Swiftblade",
    "Ironheart",
    "the Defender",
    "Gatewarden",
    "the Hold",
    "Holdfast",
    "Neverfall",
    "Unfallen",
    "the Unfallen",
    "Woundborn",
    "Tenscars",
    "Hundredscars",
    "Shieldbiter",
    "the Rock",
    "Rockjaw",
    "Boarhide",
    "the Boar",
    "Wolfhelm",
    "the Bull",
    "Bullneck",
    "the Marshal",
    "the Warden",
    "the Pikeman",
    "the Lancer",
    "Steelfist",
    "Hardstrike",
    "Stoneshield",
    "Ironbound",
    "the Armoured",
    "Plateborn",
    "Mailcoat",
    "the Sword",
    "Bladeborn",
    "Grindstone",
    "Whetstone",
    "Shieldsplit",
    "Axebiter",
    "the Stand",
    "Standfast",
    "Unshaken",
    "the Unshaken",
    "Burnished",
    "the Tall",
    "Broadback",
    "the Broad",
    "Hornhelm",
    "Wardrum",
    "of the Anvil",
    "of Red Hill",
    "Kingsguard",
    "the Guardsman",
    "Ironbark",
    "Battlescar"
  ],
  "rogue": [
    "Quickfingers",
    "the Shadow",
    "Silvertongue",
    "the Sly",
    "Nightstep",
    "the Whisper",
    "Lightfoot",
    "the Knife",
    "the Quick",
    "Shadowstep",
    "the Fox",
    "Lockbreaker",
    "the Unseen",
    "Pickpocket",
    "Coinpurse",
    "the Cat",
    "Softstep",
    "Velvetpaw",
    "the Rat",
    "Slipknot",
    "the Eel",
    "Twoknives",
    "Dagger",
    "the Dagger",
    "Cutpurse",
    "the Cutpurse",
    "Nimble",
    "the Nimble",
    "Quickblade",
    "Blackhood",
    "the Hood",
    "Greycloak",
    "the Masked",
    "Masker",
    "the Ghost",
    "Ghoststep",
    "Nightshade",
    "the Night",
    "Darkwalk",
    "Silentfoot",
    "the Silent",
    "Glimmer",
    "Sneak",
    "the Sneak",
    "Fingersmith",
    "Lockpick",
    "the Lockpick",
    "Keyturner",
    "Shortblade",
    "Sharpwit",
    "the Clever",
    "Fastfingers",
    "Gildfinger",
    "Goldtooth",
    "Coinbiter",
    "the Magpie",
    "Moneybags",
    "Highwall",
    "Roofrunner",
    "Rooftop",
    "the Spider",
    "Cobweb",
    "Ropewalker",
    "the Rope",
    "the Smile",
    "Grin",
    "the Grin",
    "the Liar",
    "Fairface",
    "Twoface",
    "the Charmer",
    "Honeylie",
    "the Slick",
    "Slippery",
    "Oilfinger",
    "Gutterborn",
    "the Gutter",
    "of the Gutter",
    "of the Alley",
    "of the Docks",
    "of the Sewers",
    "of the Night",
    "of No House",
    "of the Mask",
    "of the Cowl",
    "of the Lock",
    "of the Back",
    "Backstab",
    "the Backstab",
    "Sidestep",
    "Shiv",
    "the Shiv",
    "Stiletto",
    "the Stiletto",
    "Needle",
    "the Needle",
    "Thinblade",
    "Hiddenblade",
    "Quietknife",
    "Thimble",
    "Tumbler",
    "the Tumbler",
    "Rattrap",
    "Duskfoot",
    "Dusk",
    "Mothwing",
    "the Moth",
    "Shade",
    "the Shade",
    "Soot",
    "Sootfinger",
    "Ashfoot",
    "Inkhand",
    "the Forger",
    "Falsehand",
    "Graspfast",
    "Lightfingers",
    "Swiftfoot",
    "the Swift",
    "Quicksilver",
    "Mercury",
    "Fleetfoot",
    "Weasel",
    "the Weasel",
    "the Ferret",
    "Ferret",
    "Mouse",
    "the Mouse",
    "Vole",
    "Jackdaw",
    "the Jackdaw",
    "Crow",
    "Raven",
    "Cuckoo",
    "the Cuckoo",
    "Sparrowhawk",
    "Sixknives",
    "Tenfingers",
    "Ninefingers",
    "Loaded Dice",
    "the Gambler",
    "Diceroll",
    "Lucky",
    "the Lucky",
    "Luckpenny",
    "Copperpenny",
    "Halfpenny",
    "Farthing",
    "Shilling",
    "the Penny",
    "the Lark",
    "Skylark",
    "Ducat",
    "Purseclip",
    "Wallclimber",
    "the Climber",
    "Cliffhanger",
    "Keyhole",
    "the Keyhole",
    "Peephole",
    "Eavesdrop",
    "the Listener",
    "Earwig",
    "Tattletale",
    "the Rumour",
    "Rumour",
    "Hearsay",
    "the Snitch",
    "the Fence",
    "Pawnbroker",
    "Grifter",
    "the Grifter",
    "Swindle",
    "Hushfoot",
    "Hush",
    "the Hush",
    "Quietstep",
    "Fogstep",
    "Mistwalk",
    "Smoke",
    "the Smoke",
    "Smokestep",
    "Cinderstep",
    "Vanish",
    "the Vanished",
    "Nowhere",
    "No-Name",
    "the Nameless",
    "Faceless",
    "Cloak",
    "Cloakfast",
    "Dirk",
    "the Dirk",
    "Kris",
    "Barb",
    "Viper",
    "the Viper",
    "Adder",
    "Asp",
    "the Asp"
  ],
  "wizard": [
    "Starweaver",
    "Runewise",
    "the Runed",
    "Spellward",
    "Spellhand",
    "Glyphwise",
    "Voidwalker",
    "Inkblood",
    "Tomewise",
    "Leybound",
    "the Wise",
    "Starseer",
    "the Grey",
    "Runecaller",
    "the Learned",
    "Spellwright",
    "of the Tower",
    "Inkfinger",
    "the Arcane",
    "Runeweaver",
    "Stargazer",
    "the Scholar",
    "Tomekeeper",
    "the Sage",
    "Spellbinder",
    "Glyphmaker",
    "the Erudite",
    "Inkstained",
    "Quillmaster",
    "the Lettered",
    "Bookworm",
    "the Archivist",
    "Scrollkeeper",
    "the Scribe",
    "Mooncaller",
    "Starfire",
    "Starcaller",
    "Moonseer",
    "Skywatcher",
    "Starreader",
    "Planewalker",
    "Voidtouched",
    "the Void",
    "Aethersworn",
    "the Aether",
    "Manaweaver",
    "Leyfinder",
    "Leywalker",
    "the Conjurer",
    "Conjurer",
    "the Evoker",
    "Evoker",
    "Diviner",
    "the Diviner",
    "Abjurer",
    "the Abjurer",
    "Illusionist",
    "Transmuter",
    "the Enchanter",
    "Spellsinger",
    "Wordcaster",
    "Truename",
    "the Truenamer",
    "Namegiver",
    "Firehand",
    "Frostfinger",
    "Stormhand",
    "Sparkfinger",
    "Emberhand",
    "Flamecaller",
    "Icecaller",
    "Thunderword",
    "Glasshand",
    "the Glass",
    "Crystalgaze",
    "the Crystal",
    "Orbkeeper",
    "Staffbearer",
    "Greystaff",
    "Whitestaff",
    "Blackstaff",
    "Oakstaff",
    "Longstaff",
    "the Staff",
    "Wandmaker",
    "Wandwright",
    "Gnarlwand",
    "of the Tome",
    "of the Scroll",
    "of the Stars",
    "of the Ink",
    "of the Rune",
    "of Many Books",
    "of the Lamp",
    "of the Circle",
    "of the Spire",
    "of the Glyph",
    "of the Lens",
    "of the Orrery",
    "Owlwise",
    "the Owl",
    "Owlfeather",
    "Greybeard",
    "Silverbeard",
    "Longbeard",
    "Whitebrow",
    "the Bearded",
    "the Pondering",
    "the Absent",
    "Farsighted",
    "Deepthinker",
    "the Thinker",
    "Mindweaver",
    "Thoughtsmith",
    "the Mind",
    "the Measured",
    "the Patient",
    "the Eldritch",
    "Eldritch",
    "Mysterious",
    "the Mystic",
    "Hexbreaker",
    "Wardwright",
    "Wardmaker",
    "Sigilsmith",
    "the Sigil",
    "Sealbreaker",
    "Sealkeeper",
    "Keymaster",
    "Riddler",
    "the Riddler",
    "the Unriddled",
    "Puzzlewise",
    "the Abstruse",
    "the Obscure",
    "Arcanist",
    "the Arcanist",
    "Thaumaturge",
    "Magus",
    "the Magus",
    "Spellscar",
    "Burnfinger",
    "the Singed",
    "Ashsleeve",
    "Smokebeard",
    "Candlewick",
    "Midnight Oil",
    "Lampblack",
    "Inkwell",
    "Parchment",
    "Vellum",
    "the Vellum",
    "Quill",
    "Goosequill",
    "Inkpot",
    "the Inkpot",
    "Bluefinger",
    "Copybook",
    "the Copyist",
    "Folio",
    "the Folio",
    "Codex",
    "the Codex",
    "Grimoire",
    "the Grimoire",
    "Tomeborn",
    "Bookbound",
    "Pagewise",
    "Pageturner",
    "Marginalia",
    "the Margin",
    "Starchart",
    "Skymap",
    "Orrery",
    "the Orrery",
    "Astrolabe",
    "Comet",
    "Cometcaller",
    "the Comet",
    "the Eclipse",
    "Eclipse",
    "Moonshadow",
    "Nightsky",
    "the Starlit",
    "Starsworn",
    "Aurora",
    "the Polaris",
    "Prism",
    "the Prism",
    "Spectrum",
    "Mirrorhand",
    "the Mirror",
    "Reflection",
    "Farseer",
    "the Far-Seer",
    "Timewise",
    "the Hourglass",
    "Hourglass",
    "Clockwise",
    "the Calculus"
  ],
  "cleric": [
    "Candlemass",
    "the Consoler",
    "Gentlehand",
    "Lightgiver",
    "the Chaste",
    "the Lamb",
    "Lambkin",
    "Peacegiver",
    "Peacemaker",
    "the Peaceful",
    "Graceward",
    "the Blest",
    "Dovekeeper",
    "the Dove",
    "Lightmender",
    "Hallowhand",
    "Holyhand",
    "Prayerhand",
    "Brightprayer",
    "the Vespers",
    "Matins",
    "of Vespers",
    "the Devout",
    "Lightbringer",
    "the Merciful",
    "Dawnkeeper",
    "the Blessed",
    "Hearthward",
    "of the Candle",
    "Truthsayer",
    "the Faithful",
    "the Pious",
    "Candlebearer",
    "the Gentle",
    "Healhand",
    "the Healer",
    "Mender",
    "the Mender",
    "Bonesetter",
    "the Kind",
    "Kindhand",
    "Warmhand",
    "Softvoice",
    "the Prayerful",
    "Prayerbook",
    "Psalmist",
    "the Psalmist",
    "Hymnal",
    "Bellringer",
    "the Bell",
    "Belltower",
    "the Abbot",
    "the Abbess",
    "the Prior",
    "the Deacon",
    "the Chaplain",
    "the Confessor",
    "Confessor",
    "Almsgiver",
    "the Almoner",
    "Breadgiver",
    "the Shepherd",
    "Shepherd",
    "the Pilgrim",
    "Pilgrim",
    "the Penitent",
    "the Humble",
    "Humblehand",
    "the Saintly",
    "Sainted",
    "the Hallowed",
    "Hallowed",
    "Godsworn",
    "Godspeaker",
    "Godtouched",
    "the Anointed",
    "Anointed",
    "Censer",
    "the Censer",
    "Incense",
    "Holywater",
    "Chalice",
    "the Chalice",
    "Altar-Born",
    "of the Altar",
    "of the Chapel",
    "of the Shrine",
    "of the Temple",
    "of the Abbey",
    "of the Hearth",
    "of Mercy",
    "of Hope",
    "of Grace",
    "of the Dawn",
    "of Light",
    "of the Faith",
    "of the Bell",
    "of the Font",
    "Lampkeeper",
    "Lanternbearer",
    "the Lantern",
    "Candleglow",
    "Wickwarden",
    "Tallow",
    "the Taper",
    "Firstlight",
    "Morninglight",
    "Dawnsinger",
    "Dawnbringer",
    "Daybreak",
    "the Daybreak",
    "Sunrise",
    "Sunblessed",
    "Sunward",
    "Brightbrow",
    "Goldhalo",
    "the Haloed",
    "Halo",
    "Gracegiver",
    "the Graceful",
    "Gracious",
    "Mercyhand",
    "Mercygiver",
    "Mercybringer",
    "the Forgiving",
    "Forgiver",
    "Absolver",
    "the Absolver",
    "Blessbringer",
    "Blessing",
    "Benedict",
    "Hopegiver",
    "Hopebringer",
    "the Hopeful",
    "Lifegiver",
    "Lifebringer",
    "Lifeward",
    "Woundbinder",
    "the Physic",
    "Salve",
    "Poultice",
    "Herbhand",
    "Balm",
    "the Balm",
    "Balmgiver",
    "Soothsong",
    "Soothe",
    "Hearthkeeper",
    "Hearthlight",
    "the Hearth",
    "Homeward",
    "the Homely",
    "the Host",
    "Breadbreaker",
    "Cupbearer",
    "Lightkeeper",
    "Beacon",
    "the Beacon",
    "Truthseeker",
    "the Truthful",
    "Truebound",
    "the Sincere",
    "the Honest",
    "the Plain",
    "Plainspoken",
    "Soulkeeper",
    "Soulmender",
    "Spiritward",
    "the Spirit",
    "Ghostlayer",
    "Gravewarden",
    "Lichbane",
    "Dirgesinger",
    "the Mourner",
    "Gravekeeper",
    "Deathward",
    "Shroudmaker",
    "Lastrites",
    "Vigilkeeper",
    "Vigilant Soul",
    "Prayerward",
    "Faithward",
    "the Believer",
    "Believer",
    "Faithkeeper",
    "Credo",
    "the Creed",
    "the Tithe",
    "Tithekeeper",
    "the Vow-Bound",
    "Sevenfold",
    "Threefold",
    "the Sevenfold",
    "the Ordained",
    "Ordained",
    "Templeborn",
    "Shrinekeeper",
    "Shrineward",
    "Relic",
    "the Relic"
  ],
  "ranger": [
    "Bowsworn",
    "Beastmaster",
    "Treewalker",
    "the Watcher",
    "Longsight",
    "Greywolf",
    "Wolfwatch",
    "Huntsman",
    "the Huntsman",
    "Mistwalker",
    "Burrowfinder",
    "Lynx",
    "the Lynx",
    "Hawkwing",
    "the Tracker",
    "Farshot",
    "Wolfsbane",
    "the Wanderer",
    "Pathfinder",
    "of the Wilds",
    "Keeneye",
    "the Hunter",
    "Trueshot",
    "Longbow",
    "the Longbow",
    "Arrowsong",
    "Fletchling",
    "the Fletcher",
    "Quiverful",
    "Bowstring",
    "Deadeye",
    "the Archer",
    "Hawkeye",
    "Eagle-Eye",
    "Sharpsight",
    "Clearsight",
    "Wideseer",
    "the Lookout",
    "Trailblazer",
    "Wayfinder",
    "Trailwise",
    "the Trail",
    "Trackwise",
    "Footprint",
    "Pawprint",
    "Spoorfinder",
    "the Stalker",
    "Deerstalker",
    "Boarhunter",
    "Bearslayer",
    "Wolfslayer",
    "Wolfrunner",
    "Wolfbrother",
    "Wolfsister",
    "the Wolf",
    "Lonewolf",
    "the Lone Wolf",
    "Packleader",
    "the Pack",
    "Houndmaster",
    "Hound",
    "the Hound",
    "Hawkfriend",
    "Falconer",
    "the Falconer",
    "Owlfriend",
    "Foxfriend",
    "Beastfriend",
    "Elkrider",
    "Stagrunner",
    "the Stag",
    "Hart",
    "Whitehart",
    "Greenleaf",
    "Leafcloak",
    "Greencloak",
    "the Cloaked",
    "Mossfoot",
    "Barkskin",
    "Pineneedle",
    "Fernwalker",
    "the Fern",
    "Brushwalker",
    "Thicket",
    "the Thicket",
    "of the Pines",
    "of the Forest",
    "of the Fens",
    "of the Border",
    "of the Ridge",
    "of the Hills",
    "of the Heath",
    "of the Steppe",
    "of the North",
    "of the Trail",
    "of the Hunt",
    "of the Bow",
    "of the Pack",
    "of the Fells",
    "Fellwalker",
    "Moorwalker",
    "Heathwalker",
    "Marshwalker",
    "Snowtracker",
    "Frostfoot",
    "Winterhunt",
    "Snowshoe",
    "the Scout",
    "Scout",
    "Outrider",
    "the Outrider",
    "Borderer",
    "the Borderer",
    "Marcher",
    "the Marcher",
    "Ridgewalker",
    "Ridgerunner",
    "Hillrunner",
    "Longstride",
    "Farstrider",
    "Wideranger",
    "the Ranger",
    "Strider",
    "the Strider",
    "Roamer",
    "the Roamer",
    "the Drifter",
    "Nomad",
    "the Nomad",
    "Rover",
    "Campfire",
    "Emberwatch",
    "Nightwatch",
    "Starguide",
    "Northstar",
    "Pathstar",
    "Compass",
    "the Compass",
    "Windward",
    "Windreader",
    "Rainscent",
    "Weatherwise",
    "Skyreader",
    "Cloudreader",
    "Stormscout",
    "Galewalker",
    "Arrowhead",
    "Flintpoint",
    "Broadhead",
    "Barbedshot",
    "Swiftarrow",
    "Silentshot",
    "Stillshot",
    "Steadyhand",
    "Twinshot",
    "Threeshot",
    "Volley",
    "the Volley",
    "Thousandshot",
    "Splitshaft",
    "Yewbow",
    "Ashbow",
    "Hornbow",
    "Elmshaft",
    "Featherfletch",
    "Goosefeather",
    "Greyfletch",
    "Redfletch",
    "the Quiver",
    "Bowyer",
    "Snare",
    "the Snare",
    "Trapper",
    "the Trapper",
    "Snaresetter",
    "Pitdigger",
    "Netcaster",
    "Lurefinder",
    "Tracklore",
    "Scentfinder",
    "Brokenbranch",
    "Twigsnap",
    "Quietbranch",
    "Softpine",
    "Underbough",
    "Canopy",
    "Treerunner",
    "the Treeline",
    "Treeline",
    "Edgewood",
    "Wildling",
    "the Wildling",
    "Wildwalker",
    "Wildheart",
    "Wildeye",
    "the Wild-Born",
    "Untamed",
    "the Untamed",
    "Outland",
    "the Outlander"
  ],
  "paladin": [
    "Honourbound",
    "Oathblade",
    "Vowblade",
    "Sunlance",
    "Lightlance",
    "Holylance",
    "the Lance",
    "Dawnlance",
    "Daystar",
    "the Daystar",
    "Morningstar",
    "Brightvow",
    "Truevow",
    "Firmvow",
    "Stillvow",
    "Ironvow",
    "Kindblade",
    "Mercyblade",
    "the Liberator",
    "Liberator",
    "Chainbreaker",
    "Lightwarden",
    "the Lightborn",
    "Haloblade",
    "of the Halo",
    "the Just",
    "Oathkeeper",
    "the Radiant",
    "Shieldheart",
    "the True",
    "Dawnblade",
    "the Vigilant",
    "of the Vow",
    "the Righteous",
    "the Pure",
    "the Noble",
    "the Valorous",
    "the Gallant",
    "the Upright",
    "Truesword",
    "Truthblade",
    "Holyblade",
    "Sunblade",
    "Lightblade",
    "Brightblade",
    "Goldblade",
    "Silverblade",
    "Holysword",
    "Lightsworn",
    "Sunsworn",
    "Dawnsworn",
    "Oathbound",
    "Vowbound",
    "Vowkeeper",
    "Vowsworn",
    "Oathbearer",
    "Oathsworn",
    "Oathtaker",
    "the Oathbound",
    "Pledgekeeper",
    "Promisekeeper",
    "Wordkeeper",
    "Lawgiver",
    "the Lawful",
    "Lawbringer",
    "Justicar",
    "the Justicar",
    "Judgement",
    "the Judge",
    "Verdict",
    "the Arbiter",
    "Arbiter",
    "Fairhand",
    "Evenhand",
    "Balanceblade",
    "Scalekeeper",
    "the Scales",
    "Rightful",
    "the Rightful",
    "Lightshield",
    "Sunshield",
    "Holyshield",
    "Silvershield",
    "Whiteshield",
    "Goldshield",
    "Aegis",
    "the Aegis",
    "Shieldbearer",
    "the Shield",
    "Protector",
    "the Protector",
    "Guardian",
    "the Guardian",
    "Shieldsworn",
    "Shieldbrother",
    "Shieldsister",
    "the Steward",
    "Defender True",
    "the Paragon",
    "Paragon",
    "the Exemplar",
    "Exemplar",
    "the Avenger",
    "Avenger",
    "the Crusader",
    "Crusader",
    "the Templar",
    "Templar",
    "Knight-Errant",
    "the Errant",
    "Errant",
    "Questor",
    "the Questor",
    "the Seeker",
    "Grailseeker",
    "Grailknight",
    "the Grail",
    "Lionheart",
    "Lionhearted",
    "the Lionheart",
    "Goldenmane",
    "Griffinheart",
    "Griffinrider",
    "Dragonbane",
    "Demonbane",
    "Fiendbane",
    "Shadowbane",
    "Darkbane",
    "Nightbane",
    "Doombane",
    "Wrongrighter",
    "Wrongbane",
    "Hellward",
    "Fiendslayer",
    "Demonslayer",
    "Dragonslayer",
    "Wyrmslayer",
    "the Shining",
    "Shining",
    "Radiance",
    "the Radiance",
    "Brightmail",
    "Silvermail",
    "Whitemail",
    "Goldmail",
    "Whitecloak",
    "Whitesteel",
    "Whiteplume",
    "Silverplume",
    "Goldplume",
    "the Plumed",
    "Brightplume",
    "Sunhelm",
    "Brighthelm",
    "Silverhelm",
    "Goldhelm",
    "the Gleaming",
    "Gleaming",
    "the Burnished",
    "Polished",
    "the Unstained",
    "Unstained",
    "the Spotless",
    "the Unsullied",
    "Unsullied",
    "Unbribed",
    "the Unbought",
    "the Selfless",
    "Selfless",
    "Gracebound",
    "Lightbound",
    "Heavenbound",
    "Starbound",
    "Sunbound",
    "Dawnbound",
    "of the Order",
    "of the Oath",
    "of the Sun",
    "of the Lion",
    "of the Rose",
    "of the Lily",
    "of the Grail",
    "of the Crown",
    "of Justice",
    "of Valour",
    "of Honour",
    "of the Light",
    "of the Pledge",
    "Dawnward",
    "Sunrider",
    "the Herald",
    "Herald",
    "Heraldic",
    "Banner",
    "the Banner",
    "Bannerbearer",
    "the Standard",
    "the Chosen",
    "Chosen",
    "Godchosen"
  ],
  "druid": [
    "Seasonsworn",
    "Barkhide",
    "Rowanwise",
    "Willowwise",
    "Yewheart",
    "Hazelwand",
    "Briarheart",
    "Mirewise",
    "Wildwood",
    "Beastcaller",
    "Thornward",
    "Greenmantle",
    "Rootwarden",
    "Mossheart",
    "Larchwise",
    "Birchbark",
    "Oakheart",
    "the Green",
    "Thornwise",
    "of the Grove",
    "Mossbeard",
    "the Wild",
    "Rootsinger",
    "Stormcaller",
    "Oakenshield",
    "Oakbark",
    "Oakroot",
    "Oaksong",
    "the Oak",
    "Oldoak",
    "Ashroot",
    "Elmroot",
    "Rootwise",
    "Deeproot",
    "Rootbound",
    "Rootborn",
    "Tanglefoot",
    "Tangleroot",
    "Bramblewise",
    "Thornheart",
    "Thornbeard",
    "Thornbrow",
    "Hollyleaf",
    "Hollywise",
    "Ivywise",
    "Ivycrown",
    "the Ivy",
    "Mistletoe",
    "Mosswise",
    "Mossback",
    "Mosscloak",
    "Mosswalker",
    "Lichenbeard",
    "Fernsinger",
    "Fernwise",
    "Greenbeard",
    "Greenhand",
    "Greenwise",
    "the Greenwood",
    "Greenwarden",
    "Leafsinger",
    "Leafwise",
    "Leafsong",
    "Seedsower",
    "Seedkeeper",
    "Sproutling",
    "Sapling",
    "the Sapling",
    "Saplingward",
    "Bloomcaller",
    "Blossom",
    "the Blossom",
    "Petalwise",
    "Flowercrown",
    "Mushroomcap",
    "Toadstool",
    "Sporewise",
    "the Mycelial",
    "Mudfoot",
    "Stormbringer",
    "Stormwise",
    "Thundercaller",
    "Thunderroot",
    "Rainbringer",
    "Raincaller",
    "Rainwise",
    "Raindancer",
    "Windcaller",
    "Windwhisper",
    "Windsinger",
    "Galecaller",
    "Hailcaller",
    "Lightningoak",
    "Cloudshaper",
    "Skyshaper",
    "Shapeshifter",
    "the Shifter",
    "Skinchanger",
    "Manyskins",
    "Manyshapes",
    "Wildshape",
    "Bearskin",
    "the Bear-Kin",
    "Wolfkin",
    "the Wolfkin",
    "Owlkin",
    "Ravenkin",
    "Stagkin",
    "Elkhorn",
    "Antler",
    "Antlercrown",
    "the Antlered",
    "Horned",
    "the Horned",
    "Hornbeard",
    "Stagheart",
    "Badgerfriend",
    "Beastspeaker",
    "Beasttongue",
    "Birdspeaker",
    "Birdtongue",
    "Treespeaker",
    "Treetongue",
    "Stonespeaker",
    "Rivertongue",
    "of the Oak",
    "of the Stones",
    "of the Moss",
    "of the Root",
    "of the Wood",
    "of the Thorn",
    "of the Rowan",
    "of the Willow",
    "of the Yew",
    "of the Hazel",
    "of the Barrow",
    "of the Mire",
    "of the Bog",
    "Seasonwise",
    "Springborn",
    "Summerkind",
    "Autumnal",
    "Winterwise",
    "Wintersleep",
    "Harvestmoon",
    "Solstice",
    "the Solstice",
    "Equinox",
    "the Equinox",
    "Midsummer",
    "Midwinter",
    "Yuletide",
    "Mayflower",
    "Firstfrost",
    "Moonwise",
    "Moonsinger",
    "Mooncircle",
    "Moonglade",
    "Starglade",
    "the Glade",
    "Gladekeeper",
    "Glademother",
    "Grovekeeper",
    "Grovewarden",
    "Groveborn",
    "Grovefather",
    "Wildmother",
    "Wildfather",
    "Earthmother",
    "Earthkin",
    "Earthsinger",
    "Stonecircle",
    "Standingstone",
    "Menhir",
    "Dolmen",
    "Cairn",
    "the Cairn",
    "Barrowwise",
    "Riverwise",
    "Springwater",
    "Wellspring",
    "Brookwise",
    "Mistcaller",
    "Fogcaller",
    "Dewdrop",
    "Morningdew",
    "Dewcatcher",
    "Bogwise",
    "Marshmother",
    "Reedsinger",
    "Rushwise",
    "the Rushes",
    "Wildflower",
    "Hedgewise",
    "Hedgewitch",
    "the Hedge",
    "Herbwise",
    "Herbwife",
    "Rootwife",
    "Simplewise"
  ],
  "bard": [
    "Sweetvoice",
    "the Merry",
    "Lutestring",
    "the Storied",
    "Songweaver",
    "the Charming",
    "Silverquill",
    "the Minstrel",
    "Silvertone",
    "Goldvoice",
    "Honeyvoice",
    "Velvetvoice",
    "Clearvoice",
    "Brightvoice",
    "the Voice",
    "Bellvoice",
    "the Songbird",
    "Songbird",
    "Nightingale",
    "Thrush",
    "Blackbird",
    "Wren-Voice",
    "the Wren",
    "Lutemaster",
    "the Lutenist",
    "Lutehand",
    "Harpstring",
    "Harper",
    "the Harper",
    "Fiddler",
    "the Fiddler",
    "Pipesong",
    "the Piper",
    "Flutesong",
    "Drumbeat",
    "Tambour",
    "Lyrehand",
    "the Lyre",
    "Mandolin",
    "Cittern",
    "the Cittern",
    "Hurdy-Gurdy",
    "Bagpipe",
    "Panpipes",
    "Whistler",
    "the Whistler",
    "Hummer",
    "Songsmith",
    "Rhymer",
    "the Rhymer",
    "Rhymesmith",
    "Versewright",
    "Versesmith",
    "the Versifier",
    "Poet",
    "the Poet",
    "Balladeer",
    "the Balladeer",
    "Ballad",
    "Sonneteer",
    "the Sonnet",
    "Couplet",
    "Refrain",
    "the Refrain",
    "Chorus",
    "the Chorus",
    "Encore",
    "the Encore",
    "Overture",
    "the Overture",
    "Cadenza",
    "Taleteller",
    "Taletold",
    "Talespinner",
    "Yarnspinner",
    "the Yarn",
    "Storyspinner",
    "Loresinger",
    "Lorekeeper",
    "Saga",
    "the Saga",
    "Sagaman",
    "Skald",
    "the Skald",
    "Chronicler",
    "Gleeman",
    "the Gleeman",
    "Jongleur",
    "Troubadour",
    "Trouvere",
    "Minnesinger",
    "Mummer",
    "the Mummer",
    "Masque",
    "the Masquer",
    "Player",
    "the Player",
    "the Jester",
    "Jester",
    "Motley",
    "the Motley",
    "Harlequin",
    "Pierrot",
    "Merrymaker",
    "Revel",
    "the Reveller",
    "Carouser",
    "Tavernsong",
    "Alesong",
    "Drinking Song",
    "Tankard",
    "Toastmaker",
    "the Toast",
    "Cupsong",
    "Wineglass",
    "of the Road",
    "of the Lute",
    "of the Song",
    "of the Tavern",
    "of the Stage",
    "of the Fair",
    "of the Ballad",
    "of the Masque",
    "of the Harp",
    "of Many Tales",
    "of the Feast",
    "of the Revel",
    "of the Hall",
    "of the Inn",
    "of the Chorus",
    "of the Muse",
    "Muse",
    "the Muse",
    "Musetouched",
    "Inspired",
    "the Inspiring",
    "Silverstring",
    "Goldstring",
    "Highnote",
    "Lownote",
    "Trill",
    "the Trill",
    "Tremolo",
    "Vibrato",
    "Crescendo",
    "Allegro",
    "Fortissimo",
    "Sweetnote",
    "Lilt",
    "the Lilt",
    "Lilting",
    "Cadence",
    "the Cadence",
    "Harmony",
    "Melody",
    "the Melodious",
    "Tunesmith",
    "Tunewise",
    "Tunecatcher",
    "Songcatcher",
    "Songcatch",
    "Silkentongue",
    "Smoothtalk",
    "the Smooth",
    "Glibtongue",
    "the Glib",
    "Wordsmith",
    "Wordweaver",
    "Wordplay",
    "the Witty",
    "Quickwit",
    "Wit",
    "Jest",
    "Mirthful",
    "the Mirthful",
    "Laughmaker",
    "Smilemaker",
    "Heartstring",
    "Heartsong",
    "Lovesong",
    "the Lovesick",
    "Swoon",
    "the Darling",
    "Darling",
    "Dearheart",
    "Starsong",
    "Moonsong",
    "Windsong",
    "Rainsong",
    "Roadsong",
    "Wayfarer",
    "the Wayfarer",
    "Vagabond",
    "the Vagabond",
    "Footloose",
    "Wanderlust",
    "Showstopper",
    "Spotlight",
    "Applause",
    "the Applauded"
  ],
  "gendered": {
    "male": [
      "the Swordsman",
      "the Last Man",
      "the Pikeman",
      "the Guardsman",
      "Huntsman",
      "the Huntsman",
      "Wolfbrother",
      "Shieldbrother",
      "Grovefather",
      "Wildfather",
      "Sagaman",
      "Gleeman",
      "the Gleeman",
      "Jongleur",
      "Greybeard",
      "Silverbeard",
      "Longbeard",
      "the Bearded",
      "Smokebeard",
      "Mossbeard",
      "Thornbeard",
      "Lichenbeard",
      "Greenbeard",
      "Hornbeard"
    ],
    "female": [
      "Shieldmaiden",
      "Wolfsister",
      "Shieldsister",
      "Glademother",
      "Wildmother",
      "Earthmother",
      "Marshmother",
      "Herbwife",
      "Rootwife",
      "Hedgewitch"
    ]
  }
}
